<template>
  <section class="ccui-app-main" v-loading="pageLoading" v-if="isRouterAlive">
    <!--    <keep-alive-->
    <!--      exclude="powerManageList,powerManageMaintain,powerManageMemberMaintain"-->
    <!--    >-->
    <!--      <router-view :key="key" />-->
    <!--    </keep-alive>-->
    <keep-alive :include="[]">
      <router-view :key="key" />
    </keep-alive>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  // 用来刷新页面
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  computed: {
    key() {
      return this.$route.fullPath;
    },
    pageLoading() {
      return this.$store.state.app.pageLoading.pageLoadingStatus;
    }
  },
  methods: {
    // note 刷新页面的方法
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
